import React, { Fragment, useContext, useState } from 'react';
import { SuggestBox } from '@mummssoftware/common-ui';
import { SuggestBoxWrapper } from '@mummssoftware/common-ui/style';
import {
  SET_MEASURE_SELECTED,
  SET_TABLE_NAME,
  SET_NEW_MEASURE,
  SHOW_TABLE,
  MEASURE_TYPE,
  SET_SCORES_METHOD,
  RESET_SCORES,
  SET_ALL_VALUES_ENTERED,
  getMeasureCategoryOptions,
  measureCategoryLabels,
  normalizeStoredMeasureType,
} from '../MeasuresContext/utils/constants';
import { MeasuresContext } from '../MeasuresContext/MeasuresContextProvider';
import { Context } from '../../context';

export const MeasuresMenu = () => {
  const { dispatch } = useContext(MeasuresContext);
  const { onMeasureSelectedChange } = useContext(Context);
  const measureCategoryOptions = getMeasureCategoryOptions();
  const storedType = normalizeStoredMeasureType(
    localStorage.getItem(MEASURE_TYPE),
  );
  const measureOption = {
    label: measureCategoryLabels[storedType],
    value: storedType,
  };

  const [boxOption, setBoxOption] = useState<mumms.OptionType>(measureOption);

  const handleChange = () => {
    dispatch({
      type: SET_SCORES_METHOD,
      payload: null,
    });
    dispatch({
      type: RESET_SCORES,
    });
    dispatch({
      type: SET_ALL_VALUES_ENTERED,
      payload: false,
    });
    dispatch({
      type: SHOW_TABLE,
      payload: false,
    });
    dispatch({
      type: SET_NEW_MEASURE,
      payload: false,
    });
    dispatch({
      type: SET_MEASURE_SELECTED,
      payload: null,
    });
    dispatch({
      type: SET_TABLE_NAME,
      payload: null,
    });
  };

  const onChange = (option: any) => {
    handleChange();
    setBoxOption(option);
    localStorage.setItem(MEASURE_TYPE, option.value);
    onMeasureSelectedChange(option.value);
  };

  return (
    <Fragment>
      <SuggestBoxWrapper width={130}>
        <SuggestBox
          options={measureCategoryOptions}
          value={boxOption}
          onChange={onChange}
        />
      </SuggestBoxWrapper>
    </Fragment>
  );
};
export default MeasuresMenu;
